export default __webpack_public_path__ + "static/media/glasses.f5a4125e.svg";